/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CreateServiceTypeDialogConfig } from './types';
import { AlertStatus, IAlert } from '../../../../../../../shared/ui/src/lib/components/alert/alert-types';

@Component({
  selector: 'sysque-create-service-type',
  templateUrl: './create-service-type.component.html',
  styleUrl: './create-service-type.component.scss',
  standalone: false
})
export class CreateServiceTypeComponent implements OnInit {
  @Input() config: CreateServiceTypeDialogConfig;
  @ViewChild('dialog') dialog!: ElementRef;

  public currentServiceType: string;
  public alertStatus = AlertStatus.Warning;
  public warningMessage = '';
  public isAlertVisible = false;

  public get alert(): IAlert {
    return {
      message: this.warningMessage,
      type: this.alertStatus,
      isDismissable: true,
    };
  }

  private alertHeight = 280;
  private alertWidth = 400;
  private withoutAlertHeight = 200;
  private withoutAlertWidth = 285;

  /**
    * Initializes the component
    */
  public ngOnInit(): void {
    this.currentServiceType = this.config.serviceTypeName;
  }

  /**
   * Change service type name
   */
  public applyChanges(): void {
    if (!this.validateServiceTypeName()) {
      return;
    }
    this.config.serviceTypeName = this.currentServiceType;
    this.config.apply();
  }

  /**
 * Validate the service type name
 */
   public validateServiceTypeName(): boolean {
    if (this.currentServiceType === '') {
      this.showAlert('Service type name cannot be empty.', AlertStatus.Warning);
      return false;
    }

    if (!/^[A-Za-z]/.test(this.currentServiceType)) {
      this.showAlert('Name must start with alphabet.', AlertStatus.Warning);
      return false;
    }

    if (this.config.serviceTypes.includes(this.currentServiceType)) {
      this.showAlert('Service type name already exists.', AlertStatus.Warning);
      return false;
    }
    return true;
  }

  /**
 * Discard all changes
 */
  public discardChanges(): void {
    // Reset the value
    this.currentServiceType = this.config.serviceTypeName;
  }

  /**
 * Close the dialog
 */
  public closeDialog(): void {
    this.config.close();
  }

  //#region alert
  private showAlert(message: string, alertStatus: AlertStatus): void {
    this.setDialogDimensions(this.alertHeight, this.alertWidth);
    this.warningMessage = message;
    this.alertStatus = alertStatus;
    this.isAlertVisible = true;
  }

  public hideAlert(): void {
    this.setDialogDimensions(this.withoutAlertHeight, this.withoutAlertWidth);
    this.warningMessage = '';
    this.isAlertVisible = false;
  }

  private setDialogDimensions(height: number | string, width: number | string): void {
    this.dialog.nativeElement.style.height = `${height}px`;
    this.dialog.nativeElement.style.width = `${width}px`;
  }

  //#endregion
}
